import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

import { getIntegrationDisplayName } from '../../../../../../common/integrations'
import { useCurrentUserIntegrations } from '../../../../../../views/Integration/useCurrentUserIntegrations'

import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks'
import {
  selectMeetingSummaryAgentDisplayablePresets,
  setMeetingSummaryDisplayablePresets,
  setMeetingSummaryDisplayedPresets,
} from '../../../../../../store/meetingSummaryAgent/meetingSummaryAgent'

import { useMeetingSummary } from '../hooks'

import { MeetingSummaryAgentDropdownButton } from './DropdownButton/MeetingSummaryAgentDropdownButton'
import { MeetingSummaryHeaderPresetButton } from './PresetButton/MeetingSummaryHeaderPresetButton'
import { MeetingSummaryAgentCopyButton } from './CopyButton/MeetingSummaryAgentCopyButton'
import { MeetingSummaryAgentEditButton } from './EditButton/MeetingSummaryAgentEditButton'
import { MeetingSummaryAgentChatButton } from './ChatButton/MeetingSummaryAgentChatButton'
import { MeetingSummaryAgentCRMButton } from './CRMButton/MeetingSummaryAgentCRMButton'
import { MeetingSummaryAgentPDFButton } from './PDFButton/MeetingSummaryAgentPDFButton'
import { MeetingSummaryAgentDocumentButton } from './DocumentButton/MeetingSummaryAgentDocumentButton'
import { MEETING_SUMMARY_HEADER_PRESETS } from './HeaderPresets'

export const MeetingSummaryAgentHeader: React.FC = () => {
  const { executeMeetingSummary } = useMeetingSummary()
  const dispatch = useAppDispatch()
  const displayablePresets = useAppSelector(selectMeetingSummaryAgentDisplayablePresets)
  const { meetingSummaryExportSupportedIntegrations } = useCurrentUserIntegrations()
  const [stickied, setStickied] = useState<boolean>(false)
  const headerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    dispatch(setMeetingSummaryDisplayablePresets(MEETING_SUMMARY_HEADER_PRESETS))
    dispatch(setMeetingSummaryDisplayedPresets(MEETING_SUMMARY_HEADER_PRESETS.map((p) => p.aiFeaturePresetId)))
  }, [dispatch])

  const handleOnScroll = () => {
    if (headerRef.current?.getBoundingClientRect().top === 0) {
      setStickied(true)
    } else {
      setStickied(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleOnScroll)
    return () => window.removeEventListener('scroll', handleOnScroll)
  }, [])

  return (
    <div
      ref={headerRef}
      className={classNames('d-flex pt-4 pb-3 meeting-summary-agent-header align-items-center gap-2 justify-content-between mb-5 flex-wrap bg-white', {
        'meeting-summary-agent-header--stickied': stickied,
      })}
    >
      <div className='d-flex align-items-center gap-2 '>
        <MeetingSummaryAgentCopyButton />

        {meetingSummaryExportSupportedIntegrations.map(({ serviceId }) => (
          <MeetingSummaryAgentCRMButton key={serviceId} serviceId={serviceId} label={getIntegrationDisplayName(serviceId)} />
        ))}
        <MeetingSummaryAgentPDFButton />
        <MeetingSummaryAgentDocumentButton />
        <MeetingSummaryAgentEditButton />
        <MeetingSummaryAgentDropdownButton executeMeetingSummary={executeMeetingSummary} />
      </div>
      <div className='d-flex gap-2 align-items-center'>
        <div className='d-flex gap-2'>
          <MeetingSummaryAgentChatButton />
        </div>
        <div className='d-flex gap-2'>
          {displayablePresets.map((headerPreset) => (
            <MeetingSummaryHeaderPresetButton key={headerPreset.aiFeaturePresetId} headerPreset={headerPreset} />
          ))}
        </div>
      </div>
    </div>
  )
}
